<ng-container [ngSwitch]="mode">
    <!-- NEW Mode Component -->
    <aumico-general-information-new
        *ngSwitchCase="GeneralInformationMode.NEW"
        [setupData]="setupData"
        [companies]="companies"
        [accountingBases]="accountingBases"
        [arTemplates]="arTemplates"
        [currencies]="currencies"
        [reportTypes]="reportTypes"
        [reportLanguages]="reportLanguages"
        [currentLanguage]="currentLanguage"
        [defaultLanguage]="defaultLanguage"
        [isCpmmActive]="isCpmmActive"
        [previousAnnualReportOptions]="previousAnnualReportOptions"
        (companySelected)="companySelected.emit($event)"
        (accountingBasisSelected)="accountingBasisSelected.emit($event)"
        (arTemplateSelected)="arTemplateSelected.emit($event)"
        (formDataChanged)="formDataChanged.emit($event)"
        (formValidChanged)="formValidChanged.emit($event)"
    >
    </aumico-general-information-new>

    <!-- AUTOFILL Mode Component -->
    <aumico-general-information-autofill
        *ngSwitchCase="GeneralInformationMode.AUTOFILL"
        [setupData]="setupData"
        [companies]="companies"
        [accountingBases]="accountingBases"
        [arTemplates]="arTemplates"
        [currencies]="currencies"
        [reportTypes]="reportTypes"
        [reportLanguages]="reportLanguages"
        [currentLanguage]="currentLanguage"
        [defaultLanguage]="defaultLanguage"
        [isCpmmActive]="isCpmmActive"
        [previousAnnualReportOptions]="previousAnnualReportOptions"
        (companySelected)="companySelected.emit($event)"
        (accountingBasisSelected)="accountingBasisSelected.emit($event)"
        (arTemplateSelected)="arTemplateSelected.emit($event)"
        (autofillReportForBalanceSelected)="autofillReportForBalanceSelected.emit($event)"
        (autofillReportForIncomeSelected)="autofillReportForIncomeSelected.emit($event)"
        (formDataChanged)="formDataChanged.emit($event)"
        (formValidChanged)="formValidChanged.emit($event)"
    >
    </aumico-general-information-autofill>

    <!-- SAVED Mode Component -->
    <aumico-general-information-saved
        *ngSwitchCase="GeneralInformationMode.SAVED"
        [setupData]="setupData"
        [companies]="companies"
        [accountingBases]="accountingBases"
        [arTemplates]="arTemplates"
        [currencies]="currencies"
        [reportTypes]="reportTypes"
        [reportLanguages]="reportLanguages"
        [savedData]="savedData"
        [currentLanguage]="currentLanguage"
        [defaultLanguage]="defaultLanguage"
        [isCpmmActive]="isCpmmActive"
        [previousAnnualReportOptions]="previousAnnualReportOptions"
        (companySelected)="companySelected.emit($event)"
        (accountingBasisSelected)="accountingBasisSelected.emit($event)"
        (arTemplateSelected)="arTemplateSelected.emit($event)"
        (formDataChanged)="formDataChanged.emit($event)"
        (formValidChanged)="formValidChanged.emit($event)"
    >
    </aumico-general-information-saved>
</ng-container>
